import { Button } from '@mui/material'
import React, { ComponentPropsWithRef, useContext, useEffect } from 'react'
import { DrawerStm } from './DrawerStm'
import { FSM_ACTIONS_TYPE, Assignation } from '../context/types'
import { useCommonCtx } from '../context/useCommonCtx'
import { info } from '../services/sentryLogger'

interface Props
    extends Omit<ComponentPropsWithRef<'div'>, 'onToggle'>,
        Pick<FSM_ACTIONS_TYPE, 'bottomCenter' | 'bottomLeft' | 'bottomRight'> {
    onToggle: (event: React.KeyboardEvent<Element> | React.MouseEvent<Element, MouseEvent>) => void
    toggled: boolean
    currentLabel?: string
    assignations: Assignation[]
}
export const NavFooter = (p: Props) => {
    const {
        className,
        bottomLeft: left,
        bottomRight: right,
        bottomCenter: center,
        ...rest
    } = p
    const { Icon: PrevIcon } = left
    // const { Icon: CenterIcon } = center
    const { Icon: NextIcon } = right
    const commons = useCommonCtx()
    const singleCTA = !left.onClick

    // FIXME remove
    // useEffect(()=> {
    //     setTimeout(() => {
    //         right.onClick && right.onClick()
    //     }, 2000);
    // },[right.onClick])

    return (
        <div className="flex justify-around mb-8" style={{ direction: 'ltr' }}>
            {left.onClick && (
                <Button
                    sx={{ minWidth: '8rem', direction: 'ltr' }}
                    variant={left.variant ?? 'outlined'}
                    disabled={!left.onClick || left.disabled}
                    onClick={left.onClick}
                    color={left.color ?? 'secondary'} // FIXME
                    startIcon={PrevIcon && <PrevIcon />}
                >
                    {left.label}
                </Button>
            )}

            <DrawerStm
                showButton={commons?.showOverviewButton}
                assignations={p.assignations}
                title={''}
                anchor="bottom"
                toggled={p.toggled}
                toggleDrawer={(e: any) => {
                    info('toggleDrawer', { e, commons })
                    if (commons.alert) {
                        commons.alert(
                            'ALERT !!! ',
                            'Are you sure you want to PROFILE?',
                            () => {
                                p.onToggle(e)
                            }
                        )
                    } else {
                        info('CTX not initialized ...')
                        p.onToggle(e)
                    }
                }}
            />
            {right.onClick && (
                <Button
                    sx={{ minWidth: '8rem', direction: 'ltr' }}
                    className={`${singleCTA ? 'w-full text-xl' : ''}`}
                    variant={right.variant ?? 'outlined'}
                    disabled={!right.onClick || right.disabled}
                    onClick={right.onClick ?? console.info}
                    color={right.color ?? 'primary'}
                    endIcon={NextIcon && !singleCTA && <NextIcon />}
                >
                    {right.label}
                </Button>
            )}
        </div>
    )
}
